export const INBOX_DEPARTMENT_RESTRICTION_KEY = 'inboxDepartmentRestrictionEnabled'
export const INBOX_EXCLUDED_DEPARTMENTS_KEY = 'inboxExcludedDepartmentIds'

function permissionRecord(value: unknown): Record<string, unknown> {
  return value && typeof value === 'object' && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : {}
}

export function readInboxExcludedDepartmentIds(permissions: unknown): string[] {
  const value = permissionRecord(permissions)[INBOX_EXCLUDED_DEPARTMENTS_KEY]
  return Array.isArray(value)
    ? [...new Set(value.filter((id): id is string => typeof id === 'string' && id.length > 0))]
    : []
}

export function inboxDepartmentRestrictionEnabled(permissions: unknown): boolean {
  return permissionRecord(permissions)[INBOX_DEPARTMENT_RESTRICTION_KEY] === true
}

/** A membership in any excluded department denies access, even with other memberships. */
export function applyInboxDepartmentRestriction<T extends Record<string, unknown>>(
  permissions: T,
  memberDepartmentIds: readonly string[] | undefined,
  policy: unknown = permissions
): T {
  if (!inboxDepartmentRestrictionEnabled(policy)) {
    return permissions
  }
  const excludedIds = readInboxExcludedDepartmentIds(policy)
  if (
    excludedIds.length === 0 ||
    (memberDepartmentIds && !memberDepartmentIds.some((id) => excludedIds.includes(id)))
  ) {
    return permissions
  }
  // Missing membership context must not bypass an enabled exclusion policy.
  return { ...permissions, conversations: [], calls: [] }
}
